import { render, staticRenderFns } from "./Timetablesixth.vue?vue&type=template&id=c25274ea&scoped=true"
import script from "./Timetablesixth.vue?vue&type=script&lang=js"
export * from "./Timetablesixth.vue?vue&type=script&lang=js"
import style0 from "./Timetablesixth.vue?vue&type=style&index=0&id=c25274ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25274ea",
  null
  
)

export default component.exports